import { createMovieClip } from "../../../../../common/functions/Functions_General";
import { GameData } from "../../../gamestate/gameData";

export class BonusSymbolPickedOverlay
{       
    private parent: PIXI.Container = new PIXI.Container();
    private activeGameData: GameData;
    private bonusSymbolSelectedBG: PIXI.extras.AnimatedSprite;
    private allSymbolsMovieClips:PIXI.extras.AnimatedSprite[]=[];
    private selectedSymbol:PIXI.extras.AnimatedSprite;
    private labelBonusGame: PIXI.Text;

    constructor(parent: PIXI.Container, activeGameData: GameData) {
        this.activeGameData = activeGameData;
        this.activeGameData;
        parent.addChild(this.parent);

        this.bonusSymbolSelectedBG = createMovieClip("specialSymbolBG", 0, 20);
        this.bonusSymbolSelectedBG.anchor.set(0.5);
        this.bonusSymbolSelectedBG.animationSpeed = 0.35;
        // this.bonusSymbolSelectedBG.scale.set(1.2);
        this.parent.addChild(this.bonusSymbolSelectedBG);
            

        let textStyle = new PIXI.TextStyle({
            fontFamily: this.activeGameData.gameTextStyle.gameFont,
            stroke:"#000000",
            strokeThickness:10,

            dropShadow: true,
            dropShadowColor: "#fff",
            dropShadowBlur: 20,
            dropShadowAngle: Math.PI / 6,
            dropShadowDistance: 0,
            fill: ["#ffffff", "#fefc9d"],
            fontWeight: "bold",
            fontSize: 80,
            lineHeight:80,
            align: "left",
            wordWrap: true,
            wordWrapWidth: 800,
          });


     

       for (let i = 0; i < 9; i++) {
        //-create movie clips with alll symbols
        let clipName = this.activeGameData.tileImgNamePast[i];
        let clipLength = this.activeGameData.tileImgEnd[i];
        this.allSymbolsMovieClips[i] = createMovieClip(clipName, 0, clipLength);
      }
      this.selectedSymbol=createMovieClip(this.activeGameData.tileImgNamePast[0], 0, this.activeGameData.tileImgEnd[0]);
      this.selectedSymbol.animationSpeed= 0.35;;
      this.parent.addChild(this.selectedSymbol);
      this.selectedSymbol.anchor.set(0.5);

      //text
      this.labelBonusGame = new PIXI.Text(this.activeGameData.gameText.specialExpandingSymbol, textStyle);
      this.labelBonusGame.anchor.set(1.4,.5);  
    //   this.parent.addChild(this.labelBonusGame);
    this.setVisible(false);
    }


    public isLandScape=(isLandscape:boolean):void=>
    {
        if(isLandscape)
        {

            this.parent.scale.set(0.45);
            this.parent.y=this.activeGameData.size[1]-145;
            this.parent.x=this.activeGameData.size[0]/2; 
        }
        else
        {
            this.parent.scale.set(0.65);
            this.parent.y=this.activeGameData.size[1]+65;
            this.parent.x=this.activeGameData.size[0]/2;  
        }
    }
    public setVisible=(bool:boolean):void=>
    {
       if(bool)
       {
        let symbolIndex=this.activeGameData.GameContext().expandingSymbol-1;
        // symbolIndex=2
        if(symbolIndex!=undefined)
        {
            this.parent.alpha=1;
            this.selectedSymbol.alpha=41;
            this.bonusSymbolSelectedBG.gotoAndPlay(0);
            this.selectedSymbol.textures=this.allSymbolsMovieClips[symbolIndex].textures;
            this.selectedSymbol.gotoAndPlay(0);
        }
       }
       else
       {
        this.parent.alpha=0;
        this.selectedSymbol.alpha=0;
        this.bonusSymbolSelectedBG.gotoAndStop(0);
        this.selectedSymbol.gotoAndStop(0);
       }
      
    }
}